import { render, staticRenderFns } from "./ModattaNewOfferAudienceTargetGroup.vue?vue&type=template&id=6d03b943"
import script from "./ModattaNewOfferAudienceTargetGroup.vue?vue&type=script&lang=js"
export * from "./ModattaNewOfferAudienceTargetGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports